import { MouseEventHandler } from "react";
import { ReactComponent as CaretRightSVG } from "../../assets/caret-right-thin.svg";

function ListItem({
  title,
  onClick,
  className,
}: {
  title: JSX.Element | string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}) {
  return (
    <button
      type="button"
      className={`list-item ${className ?? ""}`}
      onClick={onClick}
    >
      <span>{title}</span>
      <CaretRightSVG
        style={{
          transform: "rotate(180deg)",
        }}
      />
    </button>
  );
}

export default ListItem;
